import { Component, computed, input } from '@angular/core';
import { RouterLink, UrlTree } from '@angular/router';
import { ButtonModule, ButtonSeverity } from 'primeng/button';
import { CustomIcon } from '../../../core/interfaces';

@Component({
  selector: 'app-ebba-button',
  standalone: true,
  imports: [ButtonModule, RouterLink],
  templateUrl: './ebba-button.html',
  styleUrl: './ebba-button.css',
})
export class EbbaButton {
  label = input<string>('Label');
  severity = input<ButtonSeverity>('primary');
  size = input<'large' | 'small' | undefined>(undefined);
  rounded = input<string>('full');
  class = input<string>('hover:shadow-xl');
  width = input<string>('w-fit'); // ✅ use px, %, or Tailwind width classes if preferred
  height = input<string>('');
  bgColor = input<string>(''); // ✅ e.g., '#8b5cf6' or 'white'
  borderColor = input<string>(''); // ✅ e.g., '#8b5cf6'
  textColor = input<string>(''); // ✅ optional for custom text color
  link = input<string | readonly any[] | UrlTree | null | undefined>('');
  styleClass = input<string>('');
  fluid = input<boolean>(false);

  defaultClasses = 'hover:-translate-y-0.5 transition-all hover:duration-300 group ease-in-out';
  rawStyleClass = computed<string>(
    () =>
      this.defaultClasses +
      ' ' +
      (this.fluid() ? 'w-full' : this.width()) +
      ' ' +
      this.height() +
      ' ' +
      this.styleClass()
  );

  customIcon = input<CustomIcon>({
    src: '',
    alt: 'Ebba Icon',
    class: 'w-4',
    pos: 'right',
  });
}
